import { createAction } from '@reduxjs/toolkit';
import { Map as ImmutableMap } from 'immutable';

import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';

export const DIALOG_TYPE_CREDIT_SCORE_REGISTER = 'CREDIT_SCORE_REGISTRATION_DIALOG';
export const DIALOG_TYPE_CREDIT_SCORE_VERIFICATION_SENT = 'CREDIT_SCORE_VERIFICATION_SENT_DIALOG';
export const DIALOG_TYPE_CREDIT_SCORE_VERIFICATION_EVENTS = 'CREDIT_SCORE_VERIFICATION_EVENTS_DIALOG';
export const DIALOG_TYPE_CREDIT_SCORE_LOADING = 'DIALOG_TYPE_CREDIT_SCORE_LOADING';
export const DIALOG_TYPE_CREDIT_REPORT_UPDATE = 'DIALOG_TYPE_CREDIT_REPORT_UPDATE';
export const DIALOG_TYPE_LOADING = 'CREDIT_SCORE_REGISTRATION_LOADING';
export const DIALOG_TYPE_CANCEL_REGISTRATION = 'DIALOG_TYPE_CANCEL_REGISTRATION';

export const CREDIT_SCORE_REGISTRATION_FORM_DIALOG_ID = 'credit-score-registration-dialog';
export const CREDIT_SCORE_VERIFICATION_DIALOG_ID = 'credit-score-verification-sent-dialog';
export const CREDIT_SCORE_VERIFICATION_EVENTS_DIALOG_ID = 'credit-score-verification-events-dialog';
export const CREDIT_SCORE_VERIFICATION_LOADER_DIALOG_ID = 'credit-score-verification-loader';
export const CREDIT_REPORT_UPDATE_DIALOG_ID = 'credit-report-update-dialog';
export const CREDIT_REPORT_CANCEL_REGISTRATION_ID = 'credit-report-cancel-registration-dialog';

export const startCreditScoreRegistrationDialog = createAction(rootUiActions.createDialog.toString(), () => ({
  payload: rootUiTypes.mkRootUiData({
    id: CREDIT_SCORE_REGISTRATION_FORM_DIALOG_ID,
    type: DIALOG_TYPE_CREDIT_SCORE_REGISTER,
    allowNesting: true,
  }),
}));

export const triggerCreditScoreVerificationSentDialog = createAction(
  rootUiActions.createDialog.toString(),
  (isVerificationSuccess: boolean, creditProfileData: any, flowId?: string) => ({
    payload: rootUiTypes.mkRootUiData({
      id: CREDIT_SCORE_VERIFICATION_DIALOG_ID,
      type: DIALOG_TYPE_CREDIT_SCORE_VERIFICATION_SENT,
      allowNesting: true,
      props: ImmutableMap({ isVerificationSuccess, creditProfileData, flowId }),
    }),
  }),
);

export const triggerCreditScoreVerificationEventsDialog = createAction(
  rootUiActions.createDialog.toString(),
  (event: string, isSuccess: boolean, flowId?: string) => ({
    payload: rootUiTypes.mkRootUiData({
      id: CREDIT_SCORE_VERIFICATION_EVENTS_DIALOG_ID,
      type: DIALOG_TYPE_CREDIT_SCORE_VERIFICATION_EVENTS,
      allowNesting: true,
      props: ImmutableMap({ event, isSuccess, flowId }),
    }),
  }),
);

export const triggerCreditScoreVerificationLoader = createAction(rootUiActions.createDialog.toString(), () => ({
  payload: rootUiTypes.mkRootUiData({
    id: CREDIT_SCORE_VERIFICATION_LOADER_DIALOG_ID,
    type: DIALOG_TYPE_CREDIT_SCORE_LOADING,
    allowNesting: true,
  }),
}));

export const triggerCreditReportUpdateDialog = createAction(rootUiActions.createDialog.toString(), () => ({
  payload: rootUiTypes.mkRootUiData({
    id: CREDIT_REPORT_UPDATE_DIALOG_ID,
    type: DIALOG_TYPE_CREDIT_REPORT_UPDATE,
    allowNesting: false,
  }),
}));

export const triggerCancelRegistrationDialog = createAction(
  rootUiActions.createDialog.toString(),
  (flowId?: string) => ({
    payload: rootUiTypes.mkRootUiData({
      id: CREDIT_REPORT_CANCEL_REGISTRATION_ID,
      type: DIALOG_TYPE_CANCEL_REGISTRATION,
      allowNesting: true,
      props: ImmutableMap({ flowId }),
    }),
  }),
);
